import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Delivery } from 'src/app/models/delivery.schema';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { DeliveryService } from 'src/app/services/delivery.service';

@Component({
  selector: 'app-delivery-complaint-pop-up',
  templateUrl: './delivery-complaint-pop-up.component.html',
  styleUrls: ['./delivery-complaint-pop-up.component.scss']
})
export class DeliveryComplaintPopUpComponent implements OnInit {

  delivery: Delivery;
  deliveryComplaintForm: any;
  disableBtn: boolean = false;
  formValidationMsgs: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { delivery: Delivery },
    private dialogRef: MatDialogRef<DeliveryComplaintPopUpComponent>,
    private deliveryService: DeliveryService,
    private commanUsesService: CommanUsesService,
    private fb: FormBuilder,
  ) { 
    this.formValidationMsgs = {
      'complaintText': [
        { type: 'required', message: 'Obbligatorio' },
      ],
    }
    this.delivery = this.data.delivery;
    this.deliveryComplaintForm = this.fb.group({
      complaintText: ['', Validators.required]
    });
  }

  ngOnInit() {}

  async onSubmit(){
    try {
      this.disableBtn = true;
      if(this.deliveryComplaintForm.valid) {
        let promise = this.deliveryService.claimDeliveryBilling(this.delivery.id, this.deliveryComplaintForm.value);
        promise.then((res) => {
          if(res) {
            this.commanUsesService.showSnackBar("Claim email has been sended");
            this.disableBtn = false;
            this.dialogRef.close(true);
          } else {
            this.commanUsesService.showSnackBar("Something went wrong");  
          }
        }).catch((err) => {
          let errorMsg: string = ``;
          if(err.error.message === "COMPLAIN_EMAIL_EMPTY") {
            errorMsg = `L'EMAIL DI AMMINISTRAZIONE NON È ANCORA IMPOSTATA`;
          } else {
            errorMsg = err.error.message;
          }
          this.commanUsesService.showSnackBar(errorMsg);
          this.disableBtn = false;
        });
      }
    } catch (error) {
      
    }
  }

}
